import { render, staticRenderFns } from "./elearea3.vue?vue&type=template&id=024746dc&scoped=true&"
import script from "./elearea3.vue?vue&type=script&lang=js&"
export * from "./elearea3.vue?vue&type=script&lang=js&"
import style0 from "./elearea3.vue?vue&type=style&index=0&id=024746dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024746dc",
  null
  
)

export default component.exports